import React from "react";
import PropTypes from "prop-types";

const MaintenanceAwardIcon = ({ fill, width, height, boxShadow }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="45" cy="45" r="45" fill={fill} />
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="2"
        y="0"
        width="86"
        height="90"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.9995 0C24.9632 0 7.98532 13.0948 2.15723 31.1932H87.8418C82.0137 13.0948 65.0359 0 44.9995 0ZM44.9995 89.4886C24.9632 89.4886 7.98532 76.3938 2.15723 58.2955H87.8418C82.0137 76.3938 65.0359 89.4886 44.9995 89.4886Z"
          fill="#03B8EC"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          opacity="0.3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M85.909 45C85.909 67.5934 67.5934 85.9091 44.9999 85.9091C22.4064 85.9091 4.09082 67.5934 4.09082 45C4.09082 22.4065 22.4064 4.09088 44.9999 4.09088C67.5934 4.09088 85.909 22.4065 85.909 45ZM44.9999 82.8409C65.8989 82.8409 82.8408 65.8989 82.8408 45C82.8408 24.101 65.8989 7.15906 44.9999 7.15906C24.101 7.15906 7.159 24.101 7.159 45C7.159 65.8989 24.101 82.8409 44.9999 82.8409Z"
          fill="white"
        />
      </g>
      <path
        d="M13.8 49.2825C13.8 49.2825 13.6913 51.9813 12.2008 53.4928C11.4556 54.2485 9.05942 54.0895 9.05942 54.0895C9.05942 54.0895 8.86721 51.6958 9.61246 50.9401C11.103 49.4287 13.8 49.2825 13.8 49.2825Z"
        fill="white"
      />
      <path
        d="M3.49011 48.7807C3.49011 48.7807 6.1663 49.1452 7.52948 50.7724C8.21108 51.586 7.82529 53.9563 7.82529 53.9563C7.82529 53.9563 5.42412 53.9203 4.74261 53.1067C3.37956 51.4794 3.49011 48.7807 3.49011 48.7807Z"
        fill="white"
      />
      <path
        d="M12.9963 42.3537C12.9963 42.3537 12.4875 45.0062 10.7889 46.2793C9.93962 46.9159 7.5937 46.4024 7.5937 46.4024C7.5937 46.4024 7.75951 44.0067 8.60882 43.3702C10.3075 42.0972 12.9963 42.3537 12.9963 42.3537Z"
        fill="white"
      />
      <path
        d="M2.87569 40.3256C2.87569 40.3256 5.46794 41.084 6.57405 42.8957C7.12712 43.8016 6.39323 46.0882 6.39323 46.0882C6.39323 46.0882 4.02409 45.6957 3.47111 44.7898C2.36514 42.9779 2.87569 40.3256 2.87569 40.3256Z"
        fill="white"
      />
      <path
        d="M8.78858 33.9787C8.78858 33.9787 10.3403 36.1893 10.0734 38.2952C9.93995 39.3482 7.93921 40.6764 7.93921 40.6764C7.93921 40.6764 6.33342 38.8908 6.46695 37.8379C6.734 35.732 8.78858 33.9787 8.78858 33.9787Z"
        fill="white"
      />
      <path
        d="M76.2556 49.2825C76.2556 49.2825 76.3644 51.9813 77.8548 53.4928C78.6001 54.2485 80.9962 54.0895 80.9962 54.0895C80.9962 54.0895 81.1884 51.6958 80.4432 50.9401C78.9527 49.4287 76.2556 49.2825 76.2556 49.2825Z"
        fill="white"
      />
      <path
        d="M86.5656 48.7807C86.5656 48.7807 83.8894 49.1452 82.5262 50.7724C81.8446 51.586 82.2304 53.9563 82.2304 53.9563C82.2304 53.9563 84.6315 53.9203 85.3131 53.1067C86.6761 51.4794 86.5656 48.7807 86.5656 48.7807Z"
        fill="white"
      />
      <path
        d="M77.0594 42.3537C77.0594 42.3537 77.5682 45.0062 79.2667 46.2793C80.116 46.9159 82.462 46.4024 82.462 46.4024C82.462 46.4024 82.2962 44.0067 81.4468 43.3702C79.7482 42.0972 77.0594 42.3537 77.0594 42.3537Z"
        fill="white"
      />
      <path
        d="M87.18 40.3256C87.18 40.3256 84.5877 41.084 83.4816 42.8957C82.9285 43.8016 83.6624 46.0882 83.6624 46.0882C83.6624 46.0882 86.0316 45.6957 86.5845 44.7898C87.6905 42.9779 87.18 40.3256 87.18 40.3256Z"
        fill="white"
      />
      <path
        d="M81.2671 33.9787C81.2671 33.9787 79.7154 36.1893 79.9823 38.2952C80.1157 39.3482 82.1165 40.6764 82.1165 40.6764C82.1165 40.6764 83.7222 38.8908 83.5887 37.8379C83.3217 35.732 81.2671 33.9787 81.2671 33.9787Z"
        fill="white"
      />
      <path
        opacity="0.75"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.3871 43.3776L61.1532 53.1437C63.3075 55.298 63.3075 58.7918 61.1532 60.9468C58.9982 63.1011 55.5043 63.1011 53.35 60.9468L43.584 51.1808"
        fill="white"
      />
      <path
        opacity="0.75"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.9841 40.3632L37.6394 35.0185L37.6258 32.0884L32.1083 26.5709L26.5908 32.0884L32.1083 37.6059L35.0384 37.6195L40.3831 42.9643"
        fill="white"
      />
      <path
        d="M51.0498 51.2249L56.2519 56.427"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.4267 36.5149L53.5251 32.6133L59.6995 26.4389C58.7202 25.9967 57.6369 25.7444 56.4924 25.7444C52.1831 25.7444 48.6893 29.2383 48.6893 33.5476C48.6893 34.1855 48.7744 34.802 48.9188 35.3956L27.6191 56.6953L33.2723 62.3485L54.6444 41.1212C55.2381 41.2656 55.8545 41.3508 56.4924 41.3508C60.8017 41.3508 64.2956 37.8569 64.2956 33.5476C64.2956 32.4031 64.0433 31.3198 63.6011 30.3405L57.4267 36.5149Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </svg>
  );
};

MaintenanceAwardIcon.propTypes = {
  /**
   * The color of the award icon
   * Can be any CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
   */
  fill: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  boxShadow: PropTypes.bool
};

MaintenanceAwardIcon.defaultProps = {
  width: "75%",
  height: 114,
  boxShadow: true
};

export default MaintenanceAwardIcon;
